// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-download-button {
  background-color: var(--homepage-download-button-bg-color) !important;
  color: var(--homepage-download-button-color) !important;
  border-color: var(--homepage-download-button-border-color) !important;
}
.homepage-download-button:hover {
  background-color: var(--homepage-download-button-bg-color-hover) !important;
  color: var(--homepage-download-button-color-hover) !important;
  border-color: var(--homepage-download-button-border-color-hover) !important;
}
.homepage-download-button--hide-label-on-mobile .ant-btn-icon {
  margin-inline-end: 0px !important;
}
@media (min-width: 768px) {
  .homepage-download-button--hide-label-on-mobile .ant-btn-icon {
    margin-inline-end: 8px !important;
  }
}
.homepage-download-button--hide-label-on-mobile .homepage-download-button__label {
  display: none !important;
  margin-right: -5px !important;
}
@media (min-width: 768px) {
  .homepage-download-button--hide-label-on-mobile .homepage-download-button__label {
    display: inline-block !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Buttons/HomepageDownloadButton/HomepageDownloadButton.scss"],"names":[],"mappings":"AAEA;EACI,qEAAA;EACA,uDAAA;EACA,qEAAA;AADJ;AAGI;EACI,2EAAA;EACA,6DAAA;EACA,2EAAA;AADR;AAKQ;EACI,iCAAA;AAHZ;AAKY;EAHJ;IAIQ,iCAAA;EAFd;AACF;AAMI;EACI,wBAAA;EACA,6BAAA;AAJR;AAMQ;EAJJ;IAKQ,gCAAA;EAHV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
